import React from "react";
import imgrd1 from "../../../assets/Images/r-d/rd_10.jpg";
import imgrd3 from "../../../assets/Images/r-d/rd_11.jpg";

import {
  FlaskConical,
  FileText,
  PackageCheck,
  Microscope,
} from "lucide-react";

const Research_Development_Third = () => {
  const expertiseData = [
    {
      icon: FlaskConical,
      title: "Bioavailability Enhancement",
      description:
        "Liposomal delivery systems, nano-emulsion technology, sustained-release formulations.",
    },
    {
      icon: FileText,
      title: "Clean Label Innovation",
      description:
        "Natural sweeteners, vegan ingredients, preservative-free concepts.",
    },
    {
      icon: PackageCheck,
      title: "Personalized Nutrition",
      description:
        "Age-specific, lifestyle-focused, condition-targeted products.",
    },
    {
      icon: Microscope,
      title: "Ayurveda Meets Modern Science",
      description:
        "Clinically supported botanical formulations with standardized extracts.",
    },
  ];

  return (
    <section className="w-full bg-white py-12 md:py-16 overflow-hidden">

        <style>{`
          .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
          `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start mb-12 md:mb-16">
          
          {/* Left Heading */}
          <div className="relative">

            
            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#355931] leading-tight mb-6">
               Next-Gen R&D <span className="gradient-text"> Solutions
              </span>
            </h2> 

            <p className="mt-6 text-gray-500 text-sm sm:text-base leading-7 max-w-xl">
             We specialize in developing high-performance nutraceutical formulations with a strong focus on bioavailability, clean-label innovation, 
             personalized wellness, and science-backed botanical solutions to help brands stand out in competitive markets.
             Our R&D - driven approach combines advanced ingredient research, precision formulation techniques, and market-focused innovation to create effective and 
             consumer - centric health products. We support brands with customized solutions across tablets, effervescent-tablets,sachets, capsules, powders, and functional wellness categories 
             while maintaining the highest standards of quality, compliance, and scalability.
            </p>
          </div>

            {/* Right Images */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 items-start">
              
              {/* Image 1 */}
              <div className="overflow-hidden rounded-[40px]">
                <img
                  src={imgrd1}
                  alt="Research Laboratory"
                  className="w-full h-[260px] sm:h-[320px] object-cover rounded-[40px]"
                />
              </div>

              {/* Image 2 */}
              <div className="overflow-hidden rounded-[40px] sm:mt-16">
                <img
                  src={imgrd3}
                  alt="Analytical Testing"
                  className="w-full h-[260px] sm:h-[320px] object-cover rounded-[40px]"
                />
              </div>

            </div>
        </div>

        {/* Expertise Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10 md:gap-y-12">
          {expertiseData.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="grid grid-cols-[48px_1fr] gap-5 items-start"
              >
                <div className="pt-1">
                  <Icon
                    size={34}
                    strokeWidth={1.7}
                    className="text-[#355931]"
                  />
                </div>

                <div>
                  <h3 className="text-lg md:text-xl font-bold text-[#222222] mb-4">
                    {item.title}
                  </h3>

                  <p className="text-gray-500 text-sm sm:text-base leading-7">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Research_Development_Third;